import { SVGProps } from 'react';

export const ChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0605 6.70697L10.7675 12L16.0605 17.293L14.6465 18.707L7.93955 12L14.6465 5.29297L16.0605 6.70697Z"
      fill="currentColor"
    />
  </svg>
);
